module.exports = __webpack_public_path__ + "static/media/person-add.25e14dcb.svg";